/* eslint-disable react-hooks/exhaustive-deps */
import NavMenu from './NavMenu';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from './Sidebar';
import { pageLoad } from '../../App';
import { CurrentUser, FamilyFeatureValue } from '../../types';
import { useItems } from '../../features/Fetch/Items';
import Modal from "../Modals/Modal";
import { useAuth } from '../../features/Fetch/Auth';
import NavBar from './NavBar';
import { useLocation } from 'react-router-dom';
import { SyntheticEvent, useEffect, useState } from 'react';
import { Alert, CircularProgress, Drawer, IconButton, Snackbar } from '@mui/material';
import { Features } from '../../constants';
import { ModalProps, setProps } from '../../features/Slices/modalSlice';
import * as Icon from 'react-bootstrap-icons';

const Layout = (props: any) => {
	const isMobile: boolean = useSelector((state: any) => state.isMobile.value);
	const userData: CurrentUser = useSelector((state: any) => state.userData.value);
	const [getData, setGetData] = useState(false);
	const isLoading = false;
	const dispatch = useDispatch();
	const repo = useItems();
	const auth = useAuth();
	const location = useLocation();
	const useModalSpace = useSelector((state: any) => state.modalSpace.useModalSpace);
	const modal: ModalProps = useSelector((state: any) => state.modal.value);
	const [desktopDrawerOpen, setDesktopDrawerOpen] = useState(false);
	const useDrawerSidebar = !useModalSpace;

	useEffect(() => {
		if (userData.token && userData.isActive) {
			pageLoad.instance = 2;
			setGetData(true);
			auth.setUserContext().then(() => {
				repo.GetBudgetsAsync();
				repo.GetBucketNodesAsync();
				repo.GetTimeframesAsync();
				repo.GetAccountsAsync();
				repo.GetTransactionsAsync(100)
					.then(() => repo.GetTransactionsAsync(-1))
					.then(() => {
						setGetData(false);
					});
				repo.GetReceiptEmailsAsync();
				repo.GetUsersAsync();
				repo.GetCheckRequestsAsync();
			}).catch(e => {
				if (e === "unauthorized") {
					auth.logout();
				}
				setGetData(false);
			});
		}
	}, []);
	useEffect(() => {
		HideModal();
		if (pageLoad.instance === 2 && userData.token && userData.isActive) {
			auth.setUserContext().then(() => {
				repo.GetBudgetsAsync();
				repo.GetBucketNodesAsync();
				repo.GetTimeframesAsync();
				repo.GetAccountsAsync();
				repo.GetTransactionsAsync();
				repo.GetReceiptEmailsAsync();
				repo.GetUsersAsync();
				repo.GetCheckRequestsAsync();
			}).catch(e => {
				if (e === "unauthorized") {
					auth.logout();
				}
			});
		}
	}, [location.pathname]);

	return (
		<div>
			{location.pathname.startsWith('/report/') ?
				props.children
				:
				isMobile ? (
					<div className="page">
						<NavMenu GetData={setGetData} />

						<main>
							<article className="content px-1">
								{isLoading &&
									<h1>Loading...</h1>
								}
								{props.children}
							</article>
						</main>

						<div className="bottombar">
							<NavBar TransactionTitle={`${FamilyFeatureValue(userData, Features.TransactionTitle)}s`} />
						</div>
					</div>
				) : (
					<>
						{useDrawerSidebar ? (
							<>
								<div className="desktop-sidebar-toggle">
									<IconButton
										aria-label="Open sidebar"
										onClick={() => setDesktopDrawerOpen(true)}>
										<Icon.List size={35} />
									</IconButton>
								</div>
								<Drawer
									variant="temporary"
									open={desktopDrawerOpen}
									onClose={() => setDesktopDrawerOpen(false)}
									ModalProps={{ keepMounted: true }}
									sx={{
										"& .MuiDrawer-paper": { boxSizing: "border-box", width: 300 },
									}}>
									<Sidebar GetData={setGetData} OnClick={() => setDesktopDrawerOpen(false)} />
								</Drawer>
							</>
						) : (
							<Sidebar GetData={setGetData} />
						)}
						<div className={`desktop-page px-4${useModalSpace ? ' with-modal-space' : ' full-width'}${useDrawerSidebar ? ' sidebar-hidden' : ''}`}>
							<main>
								<article className="content">
									{isLoading &&
										<h1>Loading...</h1>
									}
									{props.children}
								</article>
							</main>
						</div>
					</>
				)
			}
			<Snackbar open={getData} onClose={HandleRetrievingClose}>
				<Alert severity="info" icon={<CircularProgress size={20} />} onClose={HandleRetrievingClose}>
					Retrieving Data
				</Alert>
			</Snackbar>
			<Modal />
		</div>
	);

	function HandleRetrievingClose(event?: SyntheticEvent | Event, reason?: string) {
		if (reason === 'clickaway') return;

		setGetData(false);
	}

	function HideModal() {
		dispatch(setProps({ ...modal, IsOpen: false }));
	}
}

export default Layout;